/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { SvgUser } from '@coursera/coursera-ui/svg';

import ProfileImage from 'bundles/phoenix/components/ProfileImage';

const styles = {
  anonymousIcon: css({
    backgroundColor: 'var(--cds-color-blue-50)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  rootStyle: (theme: Theme) => ({
    '.rc-ProfileImage .c-profile-initials': {
      backgroundColor: 'var(--cds-color-blue-50)',
      color: 'var(--cds-color-neutral-primary)',
    },
  }),
};

const PROFILE_IMAGE_SIZE = 32;

type Props = {
  profile: {
    fullName?: string | null;
    photoUrl?: string | null;
    isAnonymous?: boolean;
  };
  size?: number;
  alt?: string;
};

const ProfileImageCA = ({
  profile: { fullName, photoUrl, isAnonymous } = {},
  size = PROFILE_IMAGE_SIZE,
  alt,
}: Props) => {
  return (
    <div css={styles.rootStyle} className="rc-ProfileImageCA">
      {isAnonymous ? (
        <div css={styles.anonymousIcon} style={{ width: size, height: size, borderRadius: size / 2 }}>
          <SvgUser size={size / 2} />
        </div>
      ) : (
        <ProfileImage
          fullName={fullName}
          profileImageUrl={photoUrl || null}
          width={size || PROFILE_IMAGE_SIZE}
          height={size || PROFILE_IMAGE_SIZE}
          alt={alt}
        />
      )}
    </div>
  );
};

export default ProfileImageCA;
